/**
 * Интерполяция между тиками: бой идёт 30 Гц, экран — 60+ fps. Для каждой сущности помним позицию прошлого тика и
 * текущего; кадр рисуется между ними (`alpha` ∈ [0, 1]) — то есть на один тик позади, зато без рывков.
 */

/** Дальше этого за тик (единиц поля) — не движение, а перестановка: не тянем через всё поле. */
export const TELEPORT_DISTANCE = 2000;

export class Track {
  prevX = 0;
  prevY = 0;
  curX = 0;
  curY = 0;
  /** Тик последнего обновления; −1 — ещё не было. */
  frame = -1;
  /** Тик, когда сущность появилась (для проявления и возраста эффектов). */
  bornFrame = 0;

  /** Записать позицию тика `frame`. Повторный вызов в том же тике только обновляет текущую позицию. */
  update(frame: number, x: number, y: number): void {
    if (this.frame < 0) {
      this.prevX = this.curX = x;
      this.prevY = this.curY = y;
      this.bornFrame = frame;
    } else if (frame !== this.frame) {
      const dx = x - this.curX;
      const dy = y - this.curY;
      const far = dx * dx + dy * dy > TELEPORT_DISTANCE * TELEPORT_DISTANCE;
      // пропущенные тики (догоняли после подвисания) — тянем от последней известной, без скачка назад
      this.prevX = far ? x : this.curX;
      this.prevY = far ? y : this.curY;
      this.curX = x;
      this.curY = y;
    } else {
      this.curX = x;
      this.curY = y;
    }
    this.frame = frame;
  }

  x(alpha: number): number {
    return this.prevX + (this.curX - this.prevX) * alpha;
  }

  y(alpha: number): number {
    return this.prevY + (this.curY - this.prevY) * alpha;
  }

  /** Смещение за последний тик. */
  get dx(): number {
    return this.curX - this.prevX;
  }

  get dy(): number {
    return this.curY - this.prevY;
  }
}
